import { render, staticRenderFns } from "./quanzhou.vue?vue&type=template&id=2049de7d&scoped=true"
import script from "./quanzhou.vue?vue&type=script&lang=js"
export * from "./quanzhou.vue?vue&type=script&lang=js"
import style0 from "./quanzhou.vue?vue&type=style&index=0&id=2049de7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2049de7d",
  null
  
)

export default component.exports